import axios, { AxiosRequestConfig } from 'axios';

import Swal from 'sweetalert2';

import { deleteCookie } from '../utils/cookies';

import { config } from '../../config.json';

import packageJson from '../../../package.json';

const fetchClient = (
	helpers = false,
	timeout = Number(config.timeout_default)
) => {
	const defaultOptions: AxiosRequestConfig = {
		baseURL: helpers ? config.helpers_api_host : config.api_host,
		method: 'get',
		headers: {
			'Content-Type': 'application/json',
			'X-App-Key': 'db1f6bf4-3b23-4798-9168-5440a6845f4c',
			VERSION: packageJson.version,
			PLATFORM: 'web-app',
		},
		timeout: timeout,
		timeoutErrorMessage: 'timeout',
	};

	const instance = axios.create(defaultOptions);

	instance.interceptors.response.use(
		async (response) => {
			if (
				response.config.url === '/token/' ||
				response.config.url === '/user/register'
			) {
				deleteCookie('token');

				localStorage.setItem('token', response.data.access);
				instance.defaults.headers.Authorization =
					'JWT ' + localStorage.getItem('token');

				if (response.data.refresh !== null) {
					localStorage.setItem('refresh', response.data.refresh);
					deleteCookie('refresh');
				}
			}

			return response;
		},
		async (error) => {
			try {
				if (error?.message === 'timeout') {
					if (error.config.url === config.preapproved_api_host) {
						return 'timeout';
					} else {
						return Swal.fire({
							icon: 'error',
							titleText: 'Tempo esgotado',
							text: 'Verifique sua conexão com a internet e tente novamente',
							confirmButtonText: 'Fechar',
						}).then(() => {
							window.location.href = '/taker';
						});
					}
				}
				if (error.response.status === 401) {
					if (error.config.url === '/token/refresh/') {
						return Swal.fire({
							icon: 'error',
							titleText: 'Oops',
							text: 'Seu token expirou, por favor,faça login novamente.',
						}).then(() => {
							localStorage.removeItem('refresh');
							localStorage.removeItem('token');
							localStorage.removeItem('user');
							deleteCookie('refresh');
							deleteCookie('token');
							window.location.href = '/login';
						});
					}
					if (error.config.url === '/token/') return Promise.reject(error);

					await refreshToken();

					error.response.config.headers.Authorization =
						'JWT ' + localStorage.getItem('token');

					return instance.request(error.response.config);
				} else if (error.response.status === undefined) {
					return Swal.fire({
						icon: 'error',
						titleText: 'Ops!',
						text: 'Ocorreu um erro no servidor, tente novamente mais tarde',
						confirmButtonText: 'Fechar',
					}).then(() => {
						window.location.href = '/taker';
					});
				}
				return error.response;
			} catch (error) {
				return Swal.fire({
					icon: 'error',
					titleText: 'Ops!',
					text: 'Ocorreu um erro no servidor, tente novamente mais tarde',
					confirmButtonText: 'Fechar',
				}).then(() => {
					window.location.href = '/taker';
				});
			}
		}
	);

	instance.interceptors.request.use(
		(request) => {
			if (
				request.url === '/token/' ||
				request.url === '/token/refresh' ||
				request.url === '/user/register' ||
				request.url === '/v1/partners' ||
				request.url?.includes('/user/auth/')
			) {
				delete request.headers.Authorization;
			} else {
				if (!request.headers.noAuthorization) {
					request.headers.Authorization =
						'JWT ' + localStorage.getItem('token');
				} else {
					delete request.headers.noAuthorization;
				}
				request.headers['X-App-Key'] = 'db1f6bf4-3b23-4798-9168-5440a6845f4c';
				request.headers.VERSION = packageJson.version;
			}
			return request;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	const refreshToken = async () => {
		instance.defaults.baseURL = config.api_host;
		const refresh = await instance.post('/token/refresh/', {
			refresh: localStorage.getItem('refresh'),
		});
		localStorage.setItem('token', refresh.data.access);
		localStorage.setItem('refresh', refresh.data.refresh);
	};

	return instance;
};

export default fetchClient;
